import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { post2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { errorToast } from "@/shared/utils/helpers";

interface ThuisbezorgdOpenCloseRequest {
  restaurant: string;
  open_or_close: "open" | "close";
}

const useThuisbezorgdOpenCloseMutation = () => {
  const { t } = useTranslation();
  const branchId = useBranchId();

  return useMutation({
    mutationFn: (body: ThuisbezorgdOpenCloseRequest) =>
      post2(
        `/internal/secure/pos/v2/takeaway/open/close/exception/${branchId}`,
        body
      ),
    onSuccess: () => {
      toast.success(t("success.success"));
    },
    onError: () => {
      errorToast();
    },
  });
};

export default useThuisbezorgdOpenCloseMutation;
